import { render, staticRenderFns } from "./ExclamationMark.vue?vue&type=template&id=b4ad519e&"
import script from "./ExclamationMark.vue?vue&type=script&lang=js&"
export * from "./ExclamationMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports